import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DistributedItems from './DistributedItems';

export default {
  title: 'Components/DistributedItems',
  component: DistributedItems,
  parameters: {
    layout: 'left',
  },
  tags: ['autodocs'],
  argTypes: {
    isEdit: {
      control: { type: 'boolean' },
      description: 'Enable or disable edit mode.',
      table: {
        type: { summary: 'boolean' },
        defaultValue: { summary: 'true' },
      },
    },
  },
};

const DistributedItemsTemplate = ({ isEdit = true }) => {
  const [distItems, setDistItems] = useState([]);
  const options = [
    {
      id: 1,
      name: 'Food',
      description: null,
      organization_id: 1,
    },
    {
      id: 2,
      name: 'Water',
      description: null,
      organization_id: 1,
    },
    {
      id: 3,
      name: 'Hygiene Kits',
      description: null,
      organization_id: 1,
    },
    {
      id: 4,
      name: 'Clothes',
      description: null,
      organization_id: 1,
    },
    {
      id: 5,
      name: 'Furniture',
      description: null,
      organization_id: 1,
    },
    {
      id: 6,
      name: 'Appliances',
      description: null,
      organization_id: 1,
    },
    {
      id: 7,
      name: 'Emergency Kits',
      description: null,
      organization_id: 1,
    },
    {
      id: 8,
      name: 'Books',
      description: null,
      organization_id: 1,
    },
    {
      id: 9,
      name: 'Sport Equipment',
      description: null,
      organization_id: 1,
    },
    {
      id: 10,
      name: 'Board Games',
      description: null,
      organization_id: 1,
    },
    {
      id: 11,
      name: 'Medication',
      description: null,
      organization_id: 1,
    },
    {
      id: 12,
      name: 'Other',
      description: null,
      organization_id: 1,
    },
  ];
  return (
    <DistributedItems isEdit={isEdit} distItems={distItems} setDistItems={setDistItems} options={options} />
  );
};

DistributedItemsTemplate.propTypes = {
  isEdit: PropTypes.bool,
};

const Template = DistributedItemsTemplate.bind({});

export const Editable = Template.bind({});
Editable.args = {
  isEdit: true,
};

export const NonEditable = Template.bind({});
NonEditable.args = {
  isEdit: false,
};
